import { customLightboxHTML, customSlideHTML } from '../constants/glightboxStructure';

const selectors = {
  item: '.js-glightbox',
  section: '.js-glightbox-section',
  lightbox: '.glightbox-container',
  prevBtn: '.gbtn-custom--prev',
  nextBtn: '.gbtn-custom--next',
  slideNumber: '.gslide-number',
  slideCurrentNumber: '.gslide-number-current',
  slideAllNumber: '.gslide-number-all',
};

const classNames = {
  blur: 'blurred',
};

const toggleBlur = () => {
  document.body.classList.toggle(classNames.blur);
};

const loadGlighbox = async () => {
  const { default: GLightbox } = await import('glightbox');
  await import('glightbox/dist/css/glightbox.min.css');

  return GLightbox;
};

const observeElement = (element) => {
  const config = { attributes: true };

  // MutationObserver listens for 'closing' className on glighbox container
  // It will fire only when class 'closing' is added because modal is fully unmounted on close event
  const observer = new MutationObserver((entries, observer) => {
    const [entry] = entries;

    toggleBlur();
    observer.disconnect(entry.target);
  });

  observer.observe(element, config);
};

export let lightbox;

const handleGlightbox = () => {
  const section = document.querySelector(selectors.section);

  if (!section) return;

  let prevBtn = null;
  let nextBtn = null;
  let slidesCount = 0;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(async (entry) => {
      if (!entry.isIntersecting) return;

      const { target: section } = entry;

      const GLightbox = await loadGlighbox();

      try {
        lightbox = GLightbox({
          lightboxHTML: customLightboxHTML,
          slideHTML: customSlideHTML,
          selector: selectors.item,
          moreLength: 0,
          closeEffect: 'fade',
          openEffect: 'fade',
          closeOnOutsideClick: false,
        });

        lightbox.on('open', () => {
          const lightboxElem = document.querySelector(selectors.lightbox);
          observeElement(lightboxElem); // It fires on lighbox close

          const { elements: slides } = lightbox;
          slidesCount = slides.length;

          slides.forEach((slide, index) => {
            const numberContainer = slide.slideNode.querySelector(selectors.slideNumber);
            const numberCurrent = numberContainer.querySelector(selectors.slideCurrentNumber);
            const numberAll = numberContainer.querySelector(selectors.slideAllNumber);

            const slideNumber = index + 1;

            numberCurrent.textContent = slideNumber < 10 ? `0${slideNumber}` : slideNumber;
            numberAll.textContent = slidesCount < 10 ? `0${slidesCount}` : slidesCount;
          });

          const glightboxContainer = lightbox.modal;

          nextBtn = glightboxContainer.querySelector(selectors.nextBtn);
          prevBtn = glightboxContainer.querySelector(selectors.prevBtn);

          nextBtn.addEventListener('click', () => {
            lightbox.nextSlide();
          });

          prevBtn.addEventListener('click', () => {
            lightbox.prevSlide();
          });

          toggleBlur(); // It fires on lighbox open
        });

        lightbox.on('slide_before_change', ({ current }) => {
          const { index } = current;

          prevBtn?.toggleAttribute('disabled', index === 0);
          nextBtn?.toggleAttribute('disabled', index === slidesCount - 1);
        });
      } catch (error) {
        console.log(error);
      }

      observer.unobserve(section);
    });
  });

  observer.observe(section);
};
export default handleGlightbox;
